export interface DepartmentInterface {
    id: string
    heading: string;
    departmentPara: string;
  


}
export const departmentMockData: DepartmentInterface[] = [
    {
        id: "1",
        heading: "Business Analysis",
        departmentPara: "This department is for managing Business Analysts",
       


    },
    {
        id: "2",
        heading: "Human Resources",
        departmentPara: "This department is for managing Business Analysts",
        

    },
    {
        id: "3",
        heading: "Information Technology",
        departmentPara: "This department is for managing Business Analysts",
        

    },
]